import { Milestone } from './milestone.model';
import { MilestoneType } from './milestone-enums';
import { SiteWorkflowState } from '../../enums/site-workflow-state.enum';

export class DataCollectionMilestone extends Milestone {
    // Properties.
    public dataCollectionId: number;

    public targetWorkflowState: string;

    // Abstract method(s).
    public get MilestoneType(): string {
        return MilestoneType.Site;
    }

    public get Description(): string {
        let description: string = 'Undefined';

        if (this.targetWorkflowState == SiteWorkflowState.Setup)
            description = "Sets site to 'Setup' state";
        else if (this.targetWorkflowState == SiteWorkflowState.Active)
            description = "Sets site to 'Active' state";
        else if (this.targetWorkflowState == SiteWorkflowState.Closed)
            description = "Sets site to 'Closed' state";

        return description;
    }
}
